var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8264 19.535C16.0757 21.2857 11.5921 19.6406 7.8121 15.8606C4.03209 12.0806 2.38704 7.59706 4.13778 5.84631L5.2905 4.69358C6.0863 3.89779 7.39757 3.91882 8.21931 4.74057L10.0048 6.52604C10.8265 7.34778 10.8476 8.65906 10.0518 9.45485L9.80418 9.70244C9.37452 10.1321 9.33248 10.8252 9.73172 11.309C10.1168 11.7757 10.532 12.2405 10.9821 12.6906C11.4322 13.1408 11.897 13.5559 12.3637 13.941C12.8475 14.3402 13.5406 14.2982 13.9703 13.8686L14.2179 13.621C15.0137 12.8252 16.3249 12.8462 17.1467 13.6679L18.9322 15.4534C19.7539 16.2752 19.7749 17.5864 18.9791 18.3822L17.8264 19.535Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.34375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5405 9.48508C16.3219 8.9519 15.9962 8.45236 15.5632 8.01943C15.1548 7.61094 14.687 7.29788 14.1876 7.08023",
    stroke: "currentColor",
    strokeWidth: 1.34375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1872 4.03177C15.3828 4.46491 16.5046 5.16074 17.4632 6.11928C18.4457 7.10186 19.1523 8.256 19.5828 9.48536",
    stroke: "currentColor",
    strokeWidth: 1.34375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/calling.ef213ecbf0eb50f23e849c8cb23130e5.svg";
export { ForwardRef as ReactComponent };